module.exports = __webpack_public_path__ + "img/legato_dark_grey.e9d5fed1.jpg";